import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { supplierService } from '../../../services/supplierService';

const NewSupplierModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    razaoSocial: '',
    cnpj: '',
    address: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const formatCNPJ = (value) => {
    const numbers = value?.replace(/\D/g, '');
    if (numbers?.length <= 14) {
      return numbers?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return value;
  };

  const handleCNPJChange = (e) => {
    const formatted = formatCNPJ(e?.target?.value);
    setFormData(prev => ({
      ...prev,
      cnpj: formatted
    }));
  };

  const isFormValid = () => {
    return formData?.name?.trim() !== '';
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!formData?.name?.trim()) {
      setError('Por favor, preencha o nome do fornecedor.');
      return;
    }

    try {
      setLoading(true);
      setError('');

      await supplierService?.create(formData);

      setFormData({
        name: '',
        razaoSocial: '',
        cnpj: '',
        address: ''
      });

      onSuccess?.();
      onClose?.();
    } catch (err) {
      setError(err?.message || 'Erro ao cadastrar fornecedor');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="Package" size={20} className="text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground">Novo Fornecedor</h2>
              <p className="text-sm text-muted-foreground">Cadastre um novo fornecedor</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground p-2 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="mb-6 bg-error/10 border border-error/20 text-error px-4 py-3 rounded-lg flex items-center gap-2">
              <Icon name="AlertCircle" size={18} />
              <p className="text-sm">{error}</p>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Nome do Fornecedor *
              </label>
              <input
                type="text"
                name="name"
                value={formData?.name}
                onChange={handleChange}
                placeholder="Ex: CVC Turismo"
                className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Razão Social
              </label>
              <input
                type="text"
                name="razaoSocial"
                value={formData?.razaoSocial}
                onChange={handleChange}
                placeholder="Ex: CVC Brasil Operadora e Agência de Viagens S.A."
                className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                CNPJ
              </label>
              <input
                type="text"
                name="cnpj"
                value={formData?.cnpj}
                onChange={handleCNPJChange}
                placeholder="00.000.000/0000-00"
                maxLength={18}
                className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Endereço
              </label>
              <textarea
                name="address"
                value={formData?.address}
                onChange={handleChange}
                placeholder="Rua, Número, Bairro, Cidade - Estado, CEP"
                rows={3}
                className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              />
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 mt-6 pt-6 border-t border-border">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-muted-foreground hover:text-foreground border border-border rounded-lg hover:bg-muted/50 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading || !isFormValid()}
              className="px-4 py-2 bg-primary hover:bg-primary/90 text-white rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  <span>Salvando...</span>
                </>
              ) : (
                <>
                  <Icon name="Check" size={18} />
                  <span>Cadastrar Fornecedor</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewSupplierModal;